// Components
import { Card } from 'components/card'
import { Info } from 'components/info'

// Styles
import { CardContent, CardTitle } from './titledCard.styles'

interface TitledCardProps {
  title: string
  children: React.ReactNode
  info?: string
  className?:string
  className1?: string
}

export const TitledCard = ({
  title,
  children,
  info,
  className,
  className1,
  ...rest
}: TitledCardProps): React.ReactElement => {
  return (
    <Card {...rest} className={className}>
      <CardTitle className={className1}>
        {title} {info && <Info text={info} />}
      </CardTitle>
      <CardContent>{children}</CardContent>
    </Card>
  )
}
